import { useEffect, useState } from 'react'

export const useTimeoutTimer = (onTimeout: (() => void) | null) => {
  const [timeElapsed, setTimeElapsed] = useState(0)
  const [timeoutMs, setTimeoutMs] = useState(0)

  const isEnabled = timeoutMs > 0
  const timeLeft = timeoutMs - timeElapsed
  const isLongerThanTimeout = isEnabled && timeLeft <= 0

  const reset = () => {
    setTimeElapsed(0)
    setTimeoutMs(0)
  }

  useEffect(() => {
    if (!isEnabled) {
      return
    }
    const intervalId = setInterval(() => {
      setTimeElapsed(prevTimeElapsed => prevTimeElapsed + 1000)
    }, 1000)

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [isEnabled])

  useEffect(() => {
    if (isLongerThanTimeout && onTimeout) {
      onTimeout()
      reset()
    }
  }, [isLongerThanTimeout, onTimeout])

  return { timeLeft, setTimeoutMs }
}
